module.exports = __webpack_public_path__ + "static/media/rolik.73ce0549.jpg";